import React, { FC } from 'react'
import { useParams } from 'react-router-dom'
import { Box } from 'transfix-ui/core'
import { DedicatedLanesBidSubpage } from 'apps/fleet-planner/pages/dedicated-lanes/DedicatedLanesBidSubpage'
import { ModalBase, MODAL_TYPES } from 'transfix-ui'

interface IDedicatedLanesBidModalProps {
  onClose: () => void
}

export const DedicatedLanesBidModal: FC<IDedicatedLanesBidModalProps> = ({ onClose }) => {
  const { laneId } = useParams<{ laneId: string }>()

  return (
    <ModalBase
      title='Dedicated Lane'
      size={10}
      modalType={MODAL_TYPES.form}
      open
      onClose={onClose}
      dataTest='dedicated-lanes-modal'
      className='fp-loads-modal fp-load-details-modal'
      scrollableHeight
      isClose>
      <Box className='modal-column' width='100%'>
        <DedicatedLanesBidSubpage laneId={laneId} />
      </Box>
    </ModalBase>
  )
}
